import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UploadService } from 'app/shared/services/data/upload-service';
import swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { LoginService } from 'app/shared/services/login/login.service';
import { LoginConfirmComponent } from '../../login-confirm/login-confirm.component';
import { finalize } from 'rxjs/operators';
import { LoginConfirm } from 'app/model/user';
import { HttpStatusCode } from '@angular/common/http';

@Component({
  selector: 'app-download-document',
  templateUrl: './download-document.component.html',
  styleUrls: ['./download-document.component.scss']
})
export class DownloadDocumentComponent implements OnInit, OnChanges {
  private readonly FILE_TYPE_OTHER: string = 'otros'

  private activeModals: NgbModalRef[]

  private rowId: number
  private rowName: string
  private rowType: 'nomina' | 'contrato' | 'otros'
  private rowExt: string

  @Input() public row: any

  /**
   * Constructor
   * 
   * @param {UploadService} uploadService
   * @param {LoginService} loginService
   * @param {NgbModal} modalService
   * 
   */
  constructor(
    private uploadService: UploadService,
    private loginService: LoginService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.activeModals = []
  }

  ngOnChanges(changes: SimpleChanges): void {
    const row = changes['row']

    if (row && row.firstChange && row.currentValue) this.setRowValues()
  }

  private setRowValues(): void {
    const { id, name, type, ext } = this.row

    this.rowId = id
    this.rowName = name
    this.rowType = type
    this.rowExt = ext
  }

  public onDownloadFile(): void {
    const isAdmin = this.loginService.isAdmin()

    isAdmin || this.rowType === this.FILE_TYPE_OTHER ? this.downloadFile() : this.openModal()
  }

  private openModal(): void {
    const modalRef: NgbModalRef = this.modalService.open(LoginConfirmComponent)

    modalRef.componentInstance.onLoginConfirm.subscribe((data) => this.downloadFile(data))

    this.activeModals.push(modalRef)

    modalRef.result
      .then(() => this.deleteModalRef(modalRef))
      .catch(() => this.deleteModalRef(modalRef))
  }

  private deleteModalRef(modalRef: NgbModalRef): void {
    this.activeModals = this.activeModals.filter(item => item !== modalRef)
  }

  private downloadFile(loginConfirm?: LoginConfirm): void {
    this.uploadService.getUploadedFileById(this.rowId, loginConfirm)
      .pipe(
        finalize(() => this.modalService.dismissAll())
      )
      .subscribe(
        (file: ArrayBuffer) => {
          const fileBytes = file as ArrayBuffer

          const blobData = new Blob([fileBytes])

          const reader = new FileReader()
          reader.onloadend = () => {
            // Crear un enlace temporal
            const a = document.createElement('a')
            a.href = reader.result as string
            a.download = this.rowName + "." + this.rowExt

            // Simular un clic en el enlace para iniciar la descarga
            a.click()
          }

          // Leer el contenido del Blob como una URL de datos
          reader.readAsDataURL(blobData)
        },
        (error) => {
          const htmlText = error.status === HttpStatusCode.Forbidden
            ? `Ha ocurrido un error al intentar descargar el documento <br><br> Datos inválidos.`
            : `Ha ocurrido un error al intentar descargar el documento <br><br> Póngase en contacto con un administrador.`

          const alertOptions: SweetAlertOptions = {
            title: '¡Error!',
            html: htmlText,
            icon: 'error',
            customClass: {
              confirmButton: 'btn red-bg text-white ml-1'
            },
          }

          this.fireSwalAlert(alertOptions)
        }
      )
  }

  private fireSwalAlert(options: SweetAlertOptions): Promise<SweetAlertResult> {
    return swal.fire(options)
  }
}
